/* Échiquier Boutique — filtre par budget sur les pages de collection (Claude). */
(function () {
  'use strict';
  function run() {
    if (!document.body.classList.contains('template-collection')) { return; }
    var h1 = document.querySelector('#MainContent h1');
    if (!h1 || document.querySelector('.eb-budget--collection')) { return; }
    var fr = (document.documentElement.lang || 'fr').indexOf('fr') === 0;
    var path = location.pathname;
    var qs = location.search;
    var tiers = fr
      ? [['Tous les prix', ''], ['Moins de 60 €', 'filter.v.price.lte=60'], ['60 à 120 €', 'filter.v.price.gte=60&filter.v.price.lte=120'], ['120 à 250 €', 'filter.v.price.gte=120&filter.v.price.lte=250'], ['Plus de 250 €', 'filter.v.price.gte=250']]
      : [['All prices', ''], ['Under €60', 'filter.v.price.lte=60'], ['€60 to €120', 'filter.v.price.gte=60&filter.v.price.lte=120'], ['€120 to €250', 'filter.v.price.gte=120&filter.v.price.lte=250'], ['Over €250', 'filter.v.price.gte=250']];
    var box = document.createElement('div');
    box.className = 'eb-budget eb-budget--collection';
    var ul = document.createElement('ul');
    ul.className = 'eb-budget__list';
    var lab = document.createElement('li');
    lab.className = 'eb-budget__label';
    lab.textContent = fr ? 'Budget :' : 'Budget:';
    ul.appendChild(lab);
    var current = (qs.match(/filter\.v\.price\.[^#]*/) || [''])[0].replace(/&(sort_by|page)=[^&]*/g, '');
    tiers.forEach(function (t) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = path + (t[1] ? '?' + t[1] : '');
      a.textContent = t[0];
      a.rel = 'nofollow';
      if ((t[1] === '' && current === '') || (t[1] !== '' && current === t[1])) { a.className = 'is-active'; }
      li.appendChild(a);
      ul.appendChild(li);
    });
    box.appendChild(ul);
    var anchor = document.querySelector('.collection-description, #MainContent .rte') || h1;
    var target = h1.parentNode;
    target.insertBefore(box, h1.nextSibling);
  }
  if (document.readyState !== 'loading') { setTimeout(run, 0); } else { document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); }); }
})();
